export default function getSelectedItemsMeta({selectedItems}){

  

  let { cells=[], expansionNodes=[] } = selectedItems || {};


  let mappedCells = cells.map(cell => cell.join('.'));

  let mappedNodeLocation = expansionNodes.map(n => n.cellLocation.join('.'));




  let cellLocationSet = new Set([
    ...mappedCells,
    ...mappedNodeLocation
  ]);

  let cellsReached = Array.from(cellLocationSet).map(x => x.split('.').map(Number));
  

  return {
    cellsReached
  }



}
